onReady(($) => {
    const slider = document.querySelector('.testimonial-track');
    if (!slider) {
        return;
    }
    const slides = document.querySelectorAll('.testimonial-container');
    const sliderDots = document.querySelector('.testimonial-dots');
    const slideCount = slides.length;
    let index = 0;
    slider.appendChild(slides[0].cloneNode(true));

    function animateSlide(start, end) {
        return slider.animate(
            [
                {transform: `translateX(-${start * 100}%)`},
                {transform: `translateX(-${end * 100}%)`},
            ],
            {
                duration: 200,
                fill: 'forwards',
            },
        );
    }

    function dotPosition() {
        const dots = sliderDots.querySelectorAll('.dot');
        dots.forEach((dot, dotPosition) => {
            dot.classList.toggle('active', dotPosition === index % slideCount);
        });
    }

    function nextSlide() {
        const previousSlide = index;
        index++;
        animateSlide(previousSlide, index).onfinish = () => {
            if (index === slides.length) {
                slider.animate(
                    [
                        {transform: `translateX(-${index * 100}%)`},
                        {transform: `translateX(0%)`},
                    ],
                    {
                        fill: 'forwards',
                    },
                );
                index = 0;
            }
            dotPosition();
        };
    }

    const slideIntervalDelay = 5000;
    let slideInterval = setInterval(nextSlide, slideIntervalDelay);

    document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
            clearInterval(slideInterval);
            slideInterval = null;
            return;
        }
        if (slideInterval == null) {
            slideInterval = setInterval(nextSlide, slideIntervalDelay);
        }
    });

    for (let dotIndex = 0; dotIndex < slideCount; dotIndex++) {
        const dot = document.createElement('button');
        dot.classList.add('dot');
        if (dotIndex === 0) {
            dot.classList.add('active');
        }
        dot.addEventListener('click', () => {
            animateSlide(index, dotIndex);
            index = dotIndex;
            dotPosition();
        });
        sliderDots.appendChild(dot);
    }
});
